import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import './AssistantReplyFeedback.css';

export default function AssistantReplyFeedback({ reply, endpoint }) {
    const [helpful, setHelpful] = useState(reply?.helpful ?? null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => { setHelpful(reply?.helpful ?? null); }, [reply?.id, reply?.helpful]);
    if (!reply) return null;
    const rate = async (value) => {
        if (saving) return;
        setSaving(true);
        setError('');
        try {
            await api.post(endpoint, { helpful: value });
            setHelpful(value);
        } catch (_) {
            setError('Не удалось сохранить оценку. Попробуйте ещё раз.');
        } finally { setSaving(false); }
    };
    return <aside className="assistant-reply-feedback" aria-label="Оценка ответа Hermes">
        <strong>Hermes · тестовый ассистент</strong>
        <p>{reply.notice}</p>
        {/^https:\/\/widget2\.chio-chio\.ru\/city\/[1-9]\d*\/[1-9]\d*$/.test(reply.bookingUrl || '') && <p><a href={reply.bookingUrl} target="_blank" rel="noreferrer">Открыть онлайн-запись салона</a></p>}
        {reply.canRate && <div className="assistant-reply-feedback-actions">
            <button type="button" aria-pressed={helpful === true} disabled={saving} onClick={() => rate(true)}>Ответ был полезен</button>
            <button type="button" aria-pressed={helpful === false} disabled={saving} onClick={() => rate(false)}>Ответ не был полезен</button>
        </div>}
        <span role="status">{saving ? 'Сохраняем оценку…' : helpful !== null ? 'Спасибо! Ваша оценка сохранена.' : ''}</span>
        {error && <span role="alert">{error}</span>}
    </aside>;
}
